import React from "react";

const BankDetails = () => {
  const bankInfo = [
    { label: "Account Name", value: "SHREE NIRMALA SAHAJA YOGA CHARITABLE TRUST, AHMEDABAD" },
    { label: "Bank Name", value: "HDFC BANK" },
    { label: "Account Number", value: "50100810690735" },
    { label: "IFSC Code", value: "HDFC0000970" },
    { label: "Branch", value: "GANDHI ROAD, Ahmedabad" },
  ];

  return (
    <section className="bg-white py-16 px-4 sm:px-6 border-t border-green-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
          Bank Details for Donation
        </h2>
        <p className="text-gray-700 mb-10">
          You may donate directly via bank transfer using the account details below.
        </p>

        <div className="bg-green-50 rounded-xl shadow p-6 border border-green-200 space-y-4 text-left">
          {bankInfo.map((item, index) => (
            <div
              key={index}
              className="flex flex-col sm:flex-row justify-between gap-1 sm:gap-4"
            >
              <span className="font-medium text-green-800">{item.label}:</span>
              <span className="text-gray-700 text-sm sm:text-base text-right sm:text-left">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BankDetails;
